/* Styles */
import "../style/base/_common.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_forms.scss";
import "../style/components/_images.scss";
import "../style/components/_card.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_header.scss";
import "../style/layout/_footer.scss";
import "../style/pages/trend.scss";
import "../style/vendor/_jquery-ui.scss";
import "../style/components/_modal.scss";
import "../style/layout/_insertion.scss";
/* JS */
import "./components/menu";
import "@wikicasa/common/lazy";
import "@wikicasa/common/select";
import * as Common from "@wikicasa/common/common";
import * as Listing from "./components/listing";
import "@wikicasa/common/svgicons";
import Map, { getL } from "@wikicasa/common/leaflet_map";
import { formatFloat, formatInteger } from "@wikicasa/common/common";
import Autocomplete from "@wikicasa/common/autocomplete";
import IPlace from "@wikicasa/common/model/Place";
import type { Popup } from "leaflet";
import { IContact } from "./components/contact";
import { COLORS, MAP_TILER_APIKEY } from "./components/variables";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const parser = require("wellknown");

interface IAveragePrideData {
    place: IPlace,
    officeAverageSale: number,
    officeAverageRent: number,
    officeMinSale: number,
    officeMaxSale: number,
    subBusinessAverageSale: number;
    subBusinessAverageRent: number;
    subBusinessMinSale: number,
    subBusinessMaxSale: number,
    industrialAverageSale: number;
    industrialAverageRent: number;
    industrialMinSale: number,
    industrialMaxSale: number,
}

declare const _serializedPlace: string;
declare const _baseURL: string;
declare const _trendURL: string;
declare const _averagePrices: string;
declare const _serializedAveragePricesForMap: string;
declare const _hasZones: boolean;
declare const _dataNotAvailableLabel: string;
declare const _averagePriceSaleLabel: string;
declare const _averagePriceRentLabel: string;
declare const _viewDataLabel: string;
declare const _viewZoneDataLabel: string;

let L: Record<string, any>;

const mapOffice = new Map();
const mapSubBusiness = new Map();
const mapIndustrial = new Map();

let autocomplete: Autocomplete;
let place: IPlace;
let Contact: IContact;

let averagePricePlace: IAveragePrideData;

let cityURL: string;
let trendSearch: any;

const drawingOptions = {
    color: "#f0f0f0",
    fillOpacity: 0.7,
    weight: 2
}

const DEF_COLOR = "#BFBFBF"
const FILL_COLORS = {
    0: "#5e8e24",
    1: "#76B22E",
    2: "#92d049",
    3: "#ffba08",
    4: "#de7e33",
    5: "#d7263d"
}

$(() => {
    place = JSON.parse(_serializedPlace);

    const $cityInput = $("#city");
    autocomplete = new Autocomplete($cityInput);
    autocomplete.load(place);
    cityURL = place.cityURL;

    $cityInput.on("autocompleteselect", (event: JQuery.Event, ui: any) => {
        cityURL = ui.item.value.completeURL;
        window.location.href = `${_baseURL}/${_trendURL}/${cityURL}/`;
    });

    averagePricePlace = JSON.parse(_serializedAveragePricesForMap);

    const averagePrices = JSON.parse(_averagePrices);
    const averagePricesOfficeMap: Record<number, number> = {};
    const averagePricesSubBusinessMap: Record<number, number> = {};
    const averagePriceIndustrialMap: Record<number, number> = {};
    const placesList: Record<number, IAveragePrideData> = {};
    averagePrices.forEach((price: IAveragePrideData) => {
        if (price) {
            const id = _hasZones ? price.place.zoneID : price.place.cityID;
            placesList[id] = price;
            averagePricesOfficeMap[id] = price.officeAverageSale;
            averagePricesSubBusinessMap[id] = price.subBusinessAverageSale;
            averagePriceIndustrialMap[id] = price.industrialAverageSale;
        }
    });

    getL().then(([leaflet]: any) => {
        L = leaflet;
        $.ajax({
            type: "GET",
            url: _hasZones ?
                `https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/city/${place.cityID}.json` :
                `https://cdn.wk-cdn.it/files/geo_data/v1/polygonJson/province/${place.provinceID}.json`
        }).done((response: any) => {
            const features = response.polygonList;
            initOfficeMap(features, placesList, averagePricesOfficeMap);
            $("#map-subBusiness-tab").on("shown.bs.tab", () => {
                if (!mapSubBusiness.isInitialized())
                    initSubBusinessMap(features, placesList, averagePricesSubBusinessMap)
            });
            $("#map-industrial-tab").on("shown.bs.tab", () => {
                if (!mapIndustrial.isInitialized())
                    initIndustrialMap(features, placesList, averagePriceIndustrialMap)
            });
        });
    });

    Listing.init({
        list: "#list-agencies",
    });

    const $listAgencies = $("#list-agencies");

    if ($listAgencies) {
        $listAgencies.on("click", "[data-phone]", function (e: JQuery.Event) {
            e.preventDefault();

            const self = this;

            import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

                if (!Contact) {
                    Contact = module;
                    Contact.init();
                }

                Contact.showPhone(e, $(self));
            });
        });
    }
    initQuoteSearchForm(place);
});

function initOfficeMap(features: Array<string>, placesList: Record<number, IAveragePrideData>, averagePricesMap: Record<number, number>): void {
    mapOffice.init($("#map-office"), MAP_TILER_APIKEY, COLORS, {
        maxZoom: place.placeType == "P" ? 12 : 14,
        minZoom: place.placeType == "P" ? 8 : 9,
    });

    mapOffice.ready(() => {
        mapOffice.setCenter(place.latitude, place.longitude, place.placeType == "P" ? 10 : 12);

        const lowerStep = (averagePricePlace.officeAverageSale - averagePricePlace.officeMinSale) / 4;
        const upperStep = (averagePricePlace.officeMaxSale - averagePricePlace.officeAverageSale) / 4;

        if (averagePricePlace.officeMaxSale && averagePricePlace.officeMaxSale) {
            $("#map-office-legend-min").text(formatInteger(averagePricePlace.officeMinSale, true));
            $("#map-office-legend-max").text(formatInteger(averagePricePlace.officeMaxSale, true));
            $("#map-office-legend").show();
        }

        features.forEach((feature: any, i: number) => {
            const p = placesList[_hasZones ? feature.zoneId : feature.cityId];
            // le prossime 3 righe contengono informagica(tm), non toccare
            let popup: Popup;
            if (p)
                popup = L.popup().setContent(buildOfficePopupContent(p)[0]);
            const layer = L.geoJSON(parser(feature.polygon), {
                style: () => {
                    const value = averagePricesMap[_hasZones ? feature.zoneId : feature.cityId];
                    return $.extend(drawingOptions, {
                        fillColor: calcFillColor(value, averagePricePlace.officeAverageSale, lowerStep, upperStep)
                    });
                }
            }).addTo(mapOffice.getMap());

            // @ts-ignore
            layer.bindPopup(popup)
            if ((_hasZones && place.zoneID == feature.zoneId) || (!_hasZones && place.cityID == feature.cityId))
                layer.openPopup()
        });
    });
}

function initSubBusinessMap(features: Array<string>, placesList: Record<number, IAveragePrideData>, averagePricesMap: Record<number, number>): void {
    mapSubBusiness.init($("#map-subBusiness"), MAP_TILER_APIKEY, COLORS, {
        maxZoom: place.placeType == "P" ? 12 : 14,
        minZoom: place.placeType == "P" ? 8 : 9,
    });

    mapSubBusiness.ready(() => {
        mapSubBusiness.setCenter(place.latitude, place.longitude, place.placeType == "P" ? 10 : 12);

        const lowerStep = (averagePricePlace.subBusinessAverageSale - averagePricePlace.subBusinessMinSale) / 4;
        const upperStep = (averagePricePlace.subBusinessMaxSale - averagePricePlace.subBusinessAverageSale) / 4;

        if (averagePricePlace.subBusinessMinSale && averagePricePlace.subBusinessMaxSale) {
            $("#map-subBusiness-legend-min").text(formatInteger(averagePricePlace.subBusinessMinSale, true));
            $("#map-subBusiness-legend-max").text(formatInteger(averagePricePlace.subBusinessMaxSale, true));
            $("#map-subBusiness-legend").show();
        }

        features.forEach((feature: any, i: number) => {
            const p = placesList[_hasZones ? feature.zoneId : feature.cityId];
            // le prossime 3 righe contengono informagica(tm), non toccare
            let popup: Popup;
            if (p)
                popup = L.popup().setContent(buildSubBusinessPopupContent(p)[0]);
            const layer = L.geoJSON(parser(feature.polygon), {
                style: () => {
                    const value = averagePricesMap[_hasZones ? feature.zoneId : feature.cityId];
                    return $.extend(drawingOptions, {
                        fillColor: calcFillColor(value, averagePricePlace.subBusinessAverageSale, lowerStep, upperStep)
                    });
                }
            }).addTo(mapSubBusiness.getMap());

            // @ts-ignore
            layer.bindPopup(popup)
            if ((_hasZones && place.zoneID == feature.zoneId) || (!_hasZones && place.cityID == feature.cityId))
                layer.openPopup()
        });
    });
}

function initIndustrialMap(features: Array<string>, placesList: Record<number, IAveragePrideData>, averagePricesMap: Record<number, number>): void {
    mapIndustrial.init($("#map-industrial"), MAP_TILER_APIKEY, COLORS, {
        maxZoom: place.placeType == "P" ? 12 : 14,
        minZoom: place.placeType == "P" ? 8 : 9,
    });

    mapIndustrial.ready(() => {
        mapIndustrial.setCenter(place.latitude, place.longitude, place.placeType == "P" ? 10 : 12);

        const lowerStep = (averagePricePlace.industrialAverageSale - averagePricePlace.industrialMinSale) / 4;
        const upperStep = (averagePricePlace.industrialMaxSale - averagePricePlace.industrialAverageSale) / 4;

        if (averagePricePlace.industrialMinSale && averagePricePlace.industrialMaxSale) {
            $("#map-industrial-legend-min").text(formatInteger(averagePricePlace.industrialMinSale, true));
            $("#map-industrial-legend-max").text(formatInteger(averagePricePlace.industrialMaxSale, true));
            $("#map-industrial-legend").show();
        }

        features.forEach((feature: any, i: number) => {
            const p = placesList[_hasZones ? feature.zoneId : feature.cityId];
            // le prossime 3 righe contengono informagica(tm), non toccare
            let popup: Popup;
            if (p)
                popup = L.popup().setContent(buildindustrialPopupContent(p)[0]);
            const layer = L.geoJSON(parser(feature.polygon), {
                style: () => {
                    const value = averagePricesMap[_hasZones ? feature.zoneId : feature.cityId];
                    return $.extend(drawingOptions, {
                        fillColor: calcFillColor(value, averagePricePlace.industrialAverageSale, lowerStep, upperStep)
                    });
                }
            }).addTo(mapIndustrial.getMap());

            // @ts-ignore
            layer.bindPopup(popup)
            if ((_hasZones && place.zoneID == feature.zoneId) || (!_hasZones && place.cityID == feature.cityId))
                layer.openPopup()
        });
    });
}

function calcFillColor(value: number, average: number, lowerStep: number, upperStep: number): string {
    if (!value)
        return DEF_COLOR;
    if (value < average - (lowerStep * 2))
        return FILL_COLORS[0];
    if (value < average - lowerStep)
        return FILL_COLORS[1];
    if (value < average)
        return FILL_COLORS[2];
    if (value < average + upperStep)
        return FILL_COLORS[3];
    if (value < average + (upperStep * 2))
        return FILL_COLORS[4];
    return FILL_COLORS[5];
}

function buildOfficePopupContent(pricePlace: IAveragePrideData): JQuery<HTMLElement> {
    const place: IPlace = pricePlace.place;
    const elem = $(`<div class="p-15 text-center"></div>`);
    elem.append(`<p class="font-weight-bold mb-10">${_hasZones ? place.zoneName : place.cityName}</p>`);
    if (!pricePlace.officeAverageSale && !pricePlace.officeAverageRent)
        elem.append(`<p>${_dataNotAvailableLabel}</p>`)
    else {
        if (pricePlace.officeAverageSale) {
            // eslint-disable-next-line max-len
            elem.append(`<p>${_averagePriceSaleLabel} <span class="font-weight-bold">${formatInteger(pricePlace.officeAverageSale, true)}</span> &euro;/m<sup>2</sup></p>`);
        }
        if (pricePlace.officeAverageRent)
            elem.append(`<p>${_averagePriceRentLabel} <span class="font-weight-bold">${formatFloat(pricePlace.officeAverageRent)}</span> &euro;/m<sup>2</sup></p>`);
        const url = _hasZones ? `${_baseURL}/${_trendURL}/${place.cityURL}/${place.zoneURL}/` : `${_baseURL}/${_trendURL}/${place.urlPartName}/`;
        elem.append(`<a href="${url}" class="text-uppercase font-weight-bold text-primary d-block mt-10">${_hasZones ? _viewZoneDataLabel : _viewDataLabel}</a>`);
    }
    return elem;
}

function buildSubBusinessPopupContent(pricePlace: IAveragePrideData): JQuery<HTMLElement> {
    const place: IPlace = pricePlace.place;
    const elem = $(`<div class="p-15 text-center"></div>`);
    elem.append(`<p class="font-weight-bold mb-10">${_hasZones ? place.zoneName : place.cityName}</p>`);
    if (!pricePlace.subBusinessAverageSale && !pricePlace.subBusinessAverageRent)
        elem.append(`<p>${_dataNotAvailableLabel}</p>`)
    else {
        if (pricePlace.subBusinessAverageSale) {
            // eslint-disable-next-line max-len
            elem.append(`<p>${_averagePriceSaleLabel} <span class="font-weight-bold">${formatInteger(pricePlace.subBusinessAverageSale, true)}</span> &euro;/m<sup>2</sup></p>`);
        }
        if (pricePlace.subBusinessAverageRent) {
            // eslint-disable-next-line max-len
            elem.append(`<p>${_averagePriceRentLabel} <span class="font-weight-bold">${formatFloat(pricePlace.subBusinessAverageRent)}</span> &euro;/m<sup>2</sup></p>`);
        }
        const url = _hasZones ? `${_baseURL}/${_trendURL}/${place.cityURL}/${place.zoneURL}/` : `${_baseURL}/${_trendURL}/${place.urlPartName}/`;
        elem.append(`<a href="${url}" class="text-uppercase font-weight-bold text-primary d-block mt-10">${_hasZones ? _viewZoneDataLabel : _viewDataLabel}</a>`);
    }
    return elem;
}

function buildindustrialPopupContent(pricePlace: IAveragePrideData): JQuery<HTMLElement> {
    const place: IPlace = pricePlace.place;
    const elem = $(`<div class="p-15 text-center"></div>`);
    elem.append(`<p class="font-weight-bold mb-10">${_hasZones ? place.zoneName : place.cityName}</p>`);
    if (!pricePlace.industrialAverageSale && !pricePlace.industrialAverageRent)
        elem.append(`<p>${_dataNotAvailableLabel}</p>`)
    else {
        if (pricePlace.industrialAverageSale) {
            // eslint-disable-next-line max-len
            elem.append(`<p>${_averagePriceSaleLabel} <span class="font-weight-bold">${formatInteger(pricePlace.industrialAverageSale, true)}</span> &euro;/m<sup>2</sup></p>`);
        }
        if (pricePlace.industrialAverageRent) {
            // eslint-disable-next-line max-len
            elem.append(`<p>${_averagePriceRentLabel} <span class="font-weight-bold">${formatFloat(pricePlace.industrialAverageRent)}</span> &euro;/m<sup>2</sup></p>`);
        }
        const url = _hasZones ? `${_baseURL}/${_trendURL}/${place.cityURL}/${place.zoneURL}/` : `${_baseURL}/${_trendURL}/${place.urlPartName}/`;
        elem.append(`<a href="${url}" class="text-uppercase font-weight-bold text-primary d-block mt-10">${_hasZones ? _viewZoneDataLabel : _viewDataLabel}</a>`);
    }
    return elem;
}

function initQuoteSearchForm(place: IPlace): void {
    Common.observe("#trend-search-form", (elem: HTMLElement, observer: IntersectionObserver) => {
        import(/* webpackChunkName: "chunks/trend-search" */ "@wikicasa/common/trend-search").then((module: any) => {
            if (trendSearch)
                return;

            trendSearch = module;

            trendSearch.init({
                form: "#trend-search-form",
                place: place,
                redirectUrl: window["_wikicasaURL"]
            });
        });
        observer.disconnect();
    });
}